var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H14.5V15V8L12.5 4.5L11 3.5H9L7 11L9 16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2797 14.0367L12.9838 2.13354C12.1342 0.718601 11.132 0 9.99933 0C8.86646 0 7.84256 0.718761 7.0148 2.13354L0.718909 14.0367C0.239636 14.7555 0 15.3843 0 16.1029C0 17.7649 1.3725 19 3.02813 19H16.9706C18.6481 19 19.9987 17.7873 19.9987 16.1029C20.0206 15.3841 19.7591 14.7553 19.2798 14.0367H19.2797ZM8.99717 5.63711C8.97544 5.3451 9.08425 5.07564 9.28043 4.85097C9.67248 4.4468 10.3261 4.4468 10.7183 4.85097C10.9362 5.07563 11.045 5.39002 11.0015 5.70445V5.77181L10.3479 12.0827C10.3261 12.285 10.1736 12.4197 9.99934 12.4197C9.84678 12.4197 9.69436 12.24 9.67263 12.0829L8.97543 5.77197C8.97543 5.72701 8.97543 5.68204 8.99716 5.63708L8.99717 5.63711ZM9.99936 15.3618C9.43299 15.3618 8.97546 14.89 8.97546 14.3062C8.97546 13.7223 9.43303 13.2506 9.99936 13.2506C10.5657 13.2506 11.0233 13.7223 11.0233 14.3062C11.0233 14.89 10.5657 15.3618 9.99936 15.3618Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning-yellow.c0481940afc2ace10b7653e91f07ee2a.svg";
export { ForwardRef as ReactComponent };